import { render } from "./kaipiao.vue?vue&type=template&id=395f4ac0&scoped=true"
import script from "./kaipiao.vue?vue&type=script&lang=js"
export * from "./kaipiao.vue?vue&type=script&lang=js"

import "./kaipiao.vue?vue&type=style&index=0&id=395f4ac0&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395f4ac0"]])

export default __exports__